const loaders = {
  TCH (callback) {
    require.ensure(
      ['../locales/TCH'], // TCH
      (require) => callback(require('../locales/TCH')) // TCH
    )
  },
  CZE (callback) {
    require.ensure(
      ['../locales/CZE'],
      (require) => callback(require('../locales/CZE'))
    )
  },
  DAN (callback) {
    require.ensure(
      ['../locales/DAN'],
      (require) => callback(require('../locales/DAN'))
    )
  },
  DUT (callback) {
    require.ensure(
      ['../locales/DUT'],
      (require) => callback(require('../locales/DUT'))
    )
  },
  ENG (callback) {
    require.ensure(
      ['../locales/ENG'],
      (require) => callback(require('../locales/ENG'))
    )
  },
  FIN (callback) {
    require.ensure(
      ['../locales/FIN'],
      (require) => callback(require('../locales/FIN'))
    )
  },
  FRE (callback) {
    require.ensure(
      ['../locales/FRE'],
      (require) => callback(require('../locales/FRE'))
    )
  },
  HUN (callback) {
    require.ensure(
      ['../locales/HUN'],
      (require) => callback(require('../locales/HUN'))
    )
  },
  GER (callback) {
    require.ensure(
      ['../locales/GER'],
      (require) => callback(require('../locales/GER'))
    )
  },
  GRK (callback) {
    require.ensure(
      ['../locales/GRK'],
      (require) => callback(require('../locales/GRK'))
    )
  },
  ITA (callback) {
    require.ensure(
      ['../locales/ITA'],
      (require) => callback(require('../locales/ITA'))
    )
  },
  JPN (callback) {
    require.ensure(
      ['../locales/JPN'],
      (require) => callback(require('../locales/JPN'))
    )
  },
  KOR (callback) {
    require.ensure(
      ['../locales/KOR'],
      (require) => callback(require('../locales/KOR'))
    )
  },
  NOR (callback) {
    require.ensure(
      ['../locales/NOR'],
      (require) => callback(require('../locales/NOR'))
    )
  },
  POL (callback) {
    require.ensure(
      ['../locales/POL'],
      (require) => callback(require('../locales/POL'))
    )
  },
  POR (callback) {
    require.ensure(
      ['../locales/POR'],
      (require) => callback(require('../locales/POR'))
    )
  },
  ROM (callback) {
    require.ensure(
      ['../locales/ROM'],
      (require) => callback(require('../locales/ROM'))
    )
  },
  RUS (callback) {
    require.ensure(
      ['../locales/RUS'],
      (require) => callback(require('../locales/RUS'))
    )
  },
  SCH (callback) {
    require.ensure(
      ['../locales/SCH'],
      (require) => callback(require('../locales/SCH'))
    )
  },
  SPA (callback) {
    require.ensure(
      ['../locales/SPA'],
      (require) => callback(require('../locales/SPA'))
    )
  },
  SWE (callback) {
    require.ensure(
      ['../locales/SWE'],
      (require) => callback(require('../locales/SWE'))
    )
  },
  THA (callback) {
    require.ensure(
      ['../locales/THA'],
      (require) => callback(require('../locales/THA'))
    )
  },
  TUR (callback) {
    require.ensure(
      ['../locales/TUR'],
      (require) => callback(require('../locales/TUR'))
    )
  }
}

export default (locale) => {
  return new Promise((resolve) => {
    return loaders[locale]((result) => {
      return resolve(result)
    })
  })
}



// WEBPACK FOOTER //
// ./src/util/locale.js